import { BrowserRouter } from 'react-router-dom';
import Navbar from './components/Navbar';
import About from './components/sections/About';
import Project from './components/sections/project/Project';
import Skill from './components/sections/Skill';
import Footer from './components/Footer';

import './App.css';

function App() {
  
  return (
    <BrowserRouter>  
      <Navbar/>
      <About/>
      <Skill/>
      <Project/>
      <Footer/> 
    </BrowserRouter>
  );
}

export default App;
